var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_BatchModify"),
        width: _vm.$selectByLang("450px", "450px", "740px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("90px", "90px", "130px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SystemMaintenance.DataItem") } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.dataType,
                    callback: function($$v) {
                      _vm.dataType = $$v
                    },
                    expression: "dataType"
                  }
                },
                _vm._l(_vm.dataTypeList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.dataType === 0
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Superior") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "callback-params": { key: "manager" },
                      "callback-method-type": "value",
                      placeholder: " ",
                      "default-value": _vm.manager ? _vm.manager : "",
                      "method-params": { active: true },
                      filterable: ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.manager = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_UserCompany") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Office,
                      "callback-params": { key: "defaultOfficeId" },
                      "callback-method-type": "value",
                      "default-value": _vm.defaultOfficeId
                        ? _vm.defaultOfficeId
                        : "",
                      filterable: "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.officeChanged }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataType === 1
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_UserDepartment") } },
                [
                  _c("cargo-department-select", {
                    attrs: {
                      "callback-params": { key: "defaultDepId" },
                      "office-id": Number(_vm.defaultOfficeId),
                      enables: true,
                      disabled: !_vm.defaultOfficeId,
                      placeholder: " ",
                      "department-id": Number(_vm.defaultDepId)
                    },
                    on: {
                      change: function(p) {
                        _vm.defaultDepId = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirmHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }